import { Injectable } from '@angular/core';
import { HttpX } from './http-x.service';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';

@Injectable()
export class UserGroupsService extends ApiService {
  constructor(
    private http: HttpX,
    private auth: AuthService
  ) {
    super('user_group', 'user_groups', http, auth);
  }
  create() {
    return {
      name: '',
      summary: ''
    };
  }
}
